
export default {
	name: 'Empty',
	props: {
		title: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		description: {
			type: String,
			default: '暂无数据'
		},
		src: {
			type: String,
			default: 'https://oss.pzds.com/img/images/default/default_page.png'
		},
		type: {
			type: String,
			default: ''
		},
		// 空状态图宽度
		width: {
			type: String,
			default: 'auto'
		},
		// 空状态图高度
		height: {
			type: String,
			default: 'auto'
		}
	},
	computed: {
		// 是否为当前不可使用的卡券
		isCoupon() {
			return this.type?.includes('coupon_img')
		}
	}
}
